import './datasift_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.FacebookContent extends Monitoring.Models.SocialContents.DatasiftContent

  subType: ->
    if @get('facebook.type') == 'status'
      return 'fb-post'
    else
      return 'fb-comment'

  link: ->
    @interaction().author.link

  username: ->
    @name()

  userId: ->
    @get('data').facebook.author.id

  contentUrl: ->
    id = @get('data') && @get('data').facebook && @get('data').facebook.id
    if '_' in id
      [author, post] = id.split('_')
      "https://facebook.com/#{author}/posts/#{post}"


  isPublished: ->
    if @subType == 'fb-post'
      return @get('facebook.is_published')
    else
      false

  isHidden: ->
    if @subType == 'fb-post'
      return @get('facebook.is_published')
    else
      false
